import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M15.51 15.56a5 5 0 1 0 -3.51 1.44","key":"svg-1"}],["path",{"d":"M18.832 17.86a9 9 0 1 0 -6.832 3.14","key":"svg-2"}],["path",{"d":"M12 12v9","key":"svg-3"}]]

const IconRadar2 = createReactComponent('outline', 'radar-2', 'Radar2', __iconNode);

export default IconRadar2;